import type { ReactNode } from "react";

/** Champ standard : label (+ * si requis), le contrôle, et un hint optionnel.
 *  S'appuie sur `.field` (margin-bottom réel) → rythme vertical cohérent. */
export function Field({
  label,
  hint,
  required,
  children,
}: {
  label: string;
  hint?: ReactNode;
  required?: boolean;
  children: ReactNode;
}) {
  return (
    <div className="field">
      <label>
        {label}
        {required && <span style={{ color: "var(--purple)" }}> *</span>}
      </label>
      {children}
      {hint && <span className="field-hint">{hint}</span>}
    </div>
  );
}

/** Deux champs côte à côte (paires serrées : couleurs, taille+langue). */
export function FieldRow({ children }: { children: ReactNode }) {
  return <div className="field-pair">{children}</div>;
}

/** Interrupteur ON/OFF avec libellé À CÔTÉ (et pas dedans — corrige le bug de
 *  chevauchement où le texte était placé dans la boîte 40×22px du switch). */
export function Toggle({
  checked,
  onChange,
  label,
  hint,
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: ReactNode;
  hint?: ReactNode;
}) {
  return (
    <div className="toggle-field">
      <label className="toggle-row">
        <span className="toggle">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
          />
          <span className="toggle-slider" />
        </span>
        <span className="toggle-label">{label}</span>
      </label>
      {hint && <span className="field-hint toggle-hint">{hint}</span>}
    </div>
  );
}
